import { InvestmentOpportunitySortKey } from 'further-types/investment-opportunity';

export const InvestmentOpportunitySortKeyLabels: Record<
  InvestmentOpportunitySortKey,
  string
> = {
  [InvestmentOpportunitySortKey.OpenDateDesc]: 'Open date (newest first)',
  [InvestmentOpportunitySortKey.OpenDateAsc]: 'Open date (oldest first)',
  [InvestmentOpportunitySortKey.ScheduledCloseDateAsc]:
    'Scheduled close date (soonest first)',
  [InvestmentOpportunitySortKey.ScheduledCloseDateDesc]:
    'Scheduled close date (latest first)',
  [InvestmentOpportunitySortKey.NameAsc]: 'Name (A-Z)',
  [InvestmentOpportunitySortKey.NameDesc]: 'Name (Z-A)',
};

export const investmentOpportunitySortKeyOptions: Array<{
  value: InvestmentOpportunitySortKey;
  label: string;
}> = (
  [
    InvestmentOpportunitySortKey.OpenDateDesc,
    InvestmentOpportunitySortKey.OpenDateAsc,
    InvestmentOpportunitySortKey.ScheduledCloseDateAsc,
    InvestmentOpportunitySortKey.ScheduledCloseDateDesc,
    InvestmentOpportunitySortKey.NameAsc,
    InvestmentOpportunitySortKey.NameDesc,
  ] as const
).map((value) => ({
  value,
  label: InvestmentOpportunitySortKeyLabels[value],
}));
